<div class="clr-row">
  <div class="clr-col-12" *ngFor="let localTree of treeForView">
    <div class="card">
      <div class="card-header">Технология</div>
      <div class="card-block" style="padding-left: 0px;">
        <div class="card-text">
          <clr-tree>
            <clr-tree-node *clrRecursiveFor="
                let node of localTree;
                getChildren: getChildrens
              " [clrExpanded]="true">
              <div class="treenode-wrapper">
                <a href="javascript:void(0)" *ngIf="!node.node.isStoreSet()" role="tooltip" aria-haspopup="true"
                  class="tooltip" style="display: none;">
                  <clr-icon style="color: red" shape="exclamation-triangle"></clr-icon>
                  <span class="tooltip-content">Няма стойност на ПХ StoreForProdOrder</span>
                </a>
                <span class="text-crop">
                  {{ node.node.getProductName() }}
                </span>

                <div class="quanties-container">
                  <ng-template [ngIf]="!allowQuantityChange || node.node.level == 0" [ngIfElse]="elseBlock">
                    <span class="quantity-input">{{ node.node.quantity | number: '1.0-5'}}</span>
                  </ng-template>
                  <ng-template #elseBlock>
                    <input class="clr-input quantity-input"  type="number" 
                    [(ngModel)]="node.node.quantity"
                    (change)="quantityChanged(node)"
                    (keyup)="quantityChanged(node)"
                    />
                  </ng-template>
                  {{ node.node.measurementUnit?.Code || '' }}
                  &nbsp;
                  <a href="javascript:void(0)" role="tooltip" aria-haspopup="true"
                    class="tooltip tooltip-bottom-left quantity-available">
                      {{ node.node.availability | number: '1.0-3'}}
                      {{ node.node.availabilityMeasure || '' }}
                    <span class="tooltip-content">Обща наличност {{ node.node.availability | number: '1.0-3'}} {{ node.node.availabilityMeasure || '' }}</span>
                  </a>
                </div>
              </div>

              <!-- ({{node.node.product?.CustomProperty_StoreForProdOrder?.Description?.BG || '-'}})
              ({{node.node.product?.ProductType?.Name?.BG || '-'}}) -->
            </clr-tree-node>
          </clr-tree>
        </div>
      </div>
    </div>
  </div>
</div>